import './../App.css';

export default function UnderConstruction(props) {
  return <div className="container">
    <h1>Diese Seite ist in Arbeit!</h1>
  </div>;
}